import { render, staticRenderFns } from "./SelecionarModuloPage.vue?vue&type=template&id=7ae98f28&scoped=true"
import script from "./SelecionarModuloPage.vue?vue&type=script&lang=js"
export * from "./SelecionarModuloPage.vue?vue&type=script&lang=js"
import style0 from "./SelecionarModuloPage.vue?vue&type=style&index=0&id=7ae98f28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae98f28",
  null
  
)

export default component.exports